import { render, staticRenderFns } from "./ProgrammeFees.vue?vue&type=template&id=3d7c8b53&scoped=true&lang=pug"
import script from "./ProgrammeFees.vue?vue&type=script&lang=js"
export * from "./ProgrammeFees.vue?vue&type=script&lang=js"
import style0 from "./ProgrammeFees.vue?vue&type=style&index=0&id=3d7c8b53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c8b53",
  null
  
)

export default component.exports